<div class="main-container-mid-side live-comp text sl-round round-5 card">
  <div>
    <story-slider [liveSide]="'home'" [data]="this._DataHelper.liveSportsData" [filterItem]="_liveFilterItems" (clickedItem)="matchFilterBySport($event)"></story-slider>
  </div>

  <div class="odd-header live-filter-container">
    <ng-container [ngSwitch]="this._DataHelper.liveMatchFilter">
      <div *ngSwitchCase="'time'" class="time-filter-container" (click)="this.liveMatchFilterAction('league')">
        <image-loader-utils url="time-switch" extraClasses="time-filter-icon"></image-loader-utils>
        <div class="time-filter-text">{{ 'live.filter.time' | translate }}</div>
      </div>
      <div *ngSwitchCase="'league'" class="sporname-icon-container"></div>
    </ng-container>
    <div class="odd-combo-row">
      <div *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(0)" class="combo-box">
        <select [(ngModel)]="combo1SelectedOdd" (change)="oddComboChange(combo1SelectedOdd, 0)">
          <option *ngFor="let odd of oddComboList" [ngValue]="odd">
            {{ odd.OddNameLong | translate }}
            <ng-container *ngIf="odd.OddNameLong2 !== ''">
              {{ odd.OddNameLong2 | translate }}
            </ng-container>
          </option>
        </select>

        <div class="odd-titles">
          <ng-container *ngFor="let item of combo1SelectedOdd.OddTitles">
            <span> {{ item }}</span>
          </ng-container>
        </div>
      </div>

      <div *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(1)" class="combo-box">
        <select [(ngModel)]="combo2SelectedOdd" (change)="oddComboChange(combo2SelectedOdd, 1)">
          <option *ngFor="let odd of oddComboList" [ngValue]="odd">
            {{ odd.OddNameLong | translate }}
            <ng-container *ngIf="odd.OddNameLong2 !== ''">
              {{ odd.OddNameLong2 | translate }}
            </ng-container>
          </option>
        </select>
        <div class="odd-titles">
          <ng-container *ngFor="let item of combo2SelectedOdd.OddTitles">
            <span> {{ item }}</span>
          </ng-container>
        </div>
      </div>

      <div *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(2)" class="combo-box">
        <select [(ngModel)]="combo3SelectedOdd" (change)="oddComboChange(combo3SelectedOdd, 2)">
          <option *ngFor="let odd of oddComboList" [ngValue]="odd">
            {{ odd.OddNameLong | translate }}
            <ng-container *ngIf="odd.OddNameLong2 !== ''">
              {{ odd.OddNameLong2 | translate }}
            </ng-container>
          </option>
        </select>
        <div class="odd-titles">
          <ng-container *ngFor="let item of combo3SelectedOdd.OddTitles">
            <span> {{ item }}</span>
          </ng-container>
        </div>
      </div>

      <div *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(3)" class="combo-box">
        <select [(ngModel)]="combo4SelectedOdd" (change)="oddComboChange(combo4SelectedOdd, 3)">
          <option *ngFor="let odd of oddComboList" [ngValue]="odd">
            {{ odd.OddNameLong | translate }}
            <ng-container *ngIf="odd.OddNameLong2 !== ''">
              {{ odd.OddNameLong2 | translate }}
            </ng-container>
          </option>
        </select>
        <div class="odd-titles">
          <ng-container *ngFor="let item of combo4SelectedOdd.OddTitles">
            <span> {{ item }}</span>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <livematch-component
    [oddLiveMarketingValue]="oddLiveMarketingp1001Value"
    [isInitialized]="this.isInitialized"
    [_selectedOdds]="this._selectedOdds"
    [liveDataLength]="this.__ResultLiveData ? this.__ResultLiveData.length : 0"
    [__ResultLiveData]="this.fullmatch"
    [isFavSection]="false"
    [sportSliderChanges]="liveFilterSelectedSportId"></livematch-component>
</div>
